
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import DrivingHero from './components/DrivingHero';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import BookingFormSection from './components/BookingFormSection';
import StickyConsultationButton from '../../components/feature/StickyConsultationButton';
import StickyWhatsAppButton from '../../components/feature/StickyWhatsAppButton';

export default function DrivingAssistantPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Tokyo Driving Assistance Service | Rental Car Support | Tokyo Minpaku';

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setOg = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', 'Professional driving assistance for your rental car in Tokyo. Airport support, navigation help, and local guidance. Not a transportation business - we support your self-arranged rental car.');
    setMeta('keywords', 'driving assistant Tokyo, rental car support Tokyo, Tokyo sightseeing, airport assistance, navigation support, local guide Tokyo, inbound tourism, foreign visitors Japan');
    setMeta('geo.region', 'JP-13');
    setMeta('geo.placename', 'Tokyo');
    setOg('og:title', 'Tokyo Driving Assistance Service | Rental Car Support | Tokyo Minpaku');
    setOg('og:description', 'Professional driving assistance for your rental car in Tokyo. Airport support, navigation help, and local guidance from 15,000 JPY / 2 hours.');
    setOg('og:type', 'website');
    setOg('og:url', 'https://yourdomain.com/driving-assistant');

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', 'Tokyo Driving Assistance Service | Rental Car Support | Tokyo Minpaku');
    setMeta('twitter:description', 'Professional driving assistance for your rental car in Tokyo. Airport support, navigation help, and local guidance from 15,000 JPY / 2 hours.');
  }, []);

  return (
    <div className="bg-black">
      <Navbar />
      <main>
        <DrivingHero />
        <ServicesSection />
        <PricingSection />
        <BookingFormSection />
      </main>
      <Footer />
      <StickyConsultationButton />
      <StickyWhatsAppButton
        phoneNumber="819092895522"
        message="こんにちは！ドライビングアシスタントサービスについてお問い合わせしたいです。%0A%0A【ご希望日】%0A【ご利用時間】%0A【人数】%0A%0Aよろしくお願いいたします。"
        label="WhatsAppで予約"
      />
    </div>
  );
}